import CreateDGAConfigurationModal from './CreateDGAConfigurationModal';
import DGAReportsRetryModal from './DGAReportsRetryModal';
import DeleteDGAConfigurationModal from './DeleteDGAConfigurationModal';
import UpdateDGAConfigurationModal from './UpdateDGAConfigurationModal';
import UpdateDGATicketState from './UpdateDGATicketStateModal';
import DGAReportsChartModal from './reports/ChartModal';
import DGAReportsTableModal from './reports/TableModal';
import { TicketConfiguration } from './ticketConfiguration';

const DGAModals = () => {
  return (
    <>
      <UpdateDGAConfigurationModal />
      <CreateDGAConfigurationModal />
      <DGAReportsChartModal />
      <DGAReportsRetryModal />
      <TicketConfiguration />
      <UpdateDGATicketState />
      <DGAReportsTableModal />
      <DeleteDGAConfigurationModal />
    </>
  );
};

export default DGAModals;
